import { render, staticRenderFns } from "./ForbiddenKeywordsAdmin.vue?vue&type=template&id=d5dcacb2&scoped=true"
import script from "./ForbiddenKeywordsAdmin.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dcacb2",
  null
  
)

export default component.exports